export type StoreStatusChipSize = 'xs' | 'small' | 'medium' | 'big'

export const useStyles = (color?: string, size?: StoreStatusChipSize = 'medium') => {
  const sizes = {
    xs: { px: 1.4, py: 0.45, fontSize: '11px', minHeight: '22px', minWidth: '70px' },
    small: { px: 1.8, py: 0.55, fontSize: '12px', minHeight: '26px', minWidth: '80px' },
    medium: { px: 2.2, py: 0.65, fontSize: '12px', minHeight: '28px', minWidth: '90px' },
    big: { px: 2.6, py: 0.75, fontSize: '13px', minHeight: '32px', minWidth: '110px' },
  }[size]

  return {
    container: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    chip: ({ fit }: { fit: boolean }) => ({
      width: fit ? 'fit-content' : sizes.minWidth,
      minHeight: sizes.minHeight,
      maxWidth: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: sizes.px,
      py: sizes.py,
      borderRadius: '999px',
      background: color,
      boxShadow: '0 1px 0 rgba(0,0,0,0.08)',
    }),

    text: {
      fontSize: sizes.fontSize,
      color: '#fff',
      lineHeight: 1,
      textAlign: 'center',
    },
  }
}
